import React from "react";
import ClaimButton from "@components/FlowActionButtons/ClaimButton";
import { useClaimResumeCall } from "./hooks";
import { canUserClaimResumeCall } from "./utils";

interface ClaimResumeCallProps {
  refetchVesselCall: () => void;
  refetchInterruption: () => Promise<unknown>;
  vesselCallFlowData?: {
    vesselCallId: string;
    status: string;
  };
  interruptionTaskStatus?: string;
}

const LANG_BASE = "vessel-call.vessel-call-status-header";

const ClaimResumeCall: React.FC<ClaimResumeCallProps> = ({
  vesselCallFlowData,
  refetchVesselCall,
  refetchInterruption,
  interruptionTaskStatus,
}) => {
  const { onClaimResumeCall } = useClaimResumeCall(
    vesselCallFlowData?.vesselCallId,
    refetchVesselCall,
    refetchInterruption,
  );

  if (!vesselCallFlowData) {
    return null;
  }

  const isActionAvailable =
    interruptionTaskStatus !== undefined &&
    interruptionTaskStatus !== null &&
    canUserClaimResumeCall(interruptionTaskStatus, vesselCallFlowData.status);

  return (
    <ClaimButton
      langBase={LANG_BASE}
      permission="canClaimResumption"
      isActionAvailable={isActionAvailable}
      onClaim={onClaimResumeCall}
    />
  );
};

export default ClaimResumeCall;
